import {Dispatch} from 'redux';
import {BrandsAPI, MixesAPI, TastesAPI} from "../services/api/Api";
import {IBrands, IMix, ITastes} from "../constants/types";
import {AppStateType} from "../services/rootReducer";

const FETCH_DATA_TOBACCO_START = 'SelectionPreference/FETCH_DATA_TOBACCO_START';
const GET_TASTES_SUCCESS = 'SelectionPreferences/GET_TASTES_SUCCESS';
const GET_BRANDS_SUCCESS = 'SelectionPreferences/GET_BRANDS_SUCCESS';
const ADD_ACTIVE_TASTES_ID = 'SelectionPreferences/ADD_ACTIVE_TASTES_ID';
const REMOVE_ACTIVE_TASTES_ID = 'SelectionPreferences/REMOVE_ACTIVE_TASTES_ID';
const SET_ACTIVE_HARDNESS = 'SelectionPreferences/SET_ACTIVE_HARDNESS';
const REMOVE_ACTIVE_HARDNESS = 'SelectionPreferences/REMOVE_ACTIVE_HARDNESS';
const ADD_ACTIVE_BRANDS_ID = 'SelectionPreferences/ADD_ACTIVE_BRANDS_ID';
const REMOVE_ACTIVE_BRANDS_ID = 'SelectionPreferences/REMOVE_ACTIVE_BRANDS_ID';
const GET_MIXER_PREF_START = 'SelectionPreferences/GET_MIXER_PREF_START';
const GET_MIXER_PREF_SUCCESS = 'SelectionPreferences/GET_MIXER_PREF_SUCCESS';
const SET_CURRENT_MIX = 'SelectionPreferences/SET_CURRENT_MIX';
const UPDATE_PREFERENCES_MIX = 'SelectionPreferences/UPDATE_PREFERENCES_MIX';
const CLEAN_PREFERENCES = 'SelectionPreferences/CLEAN_PREFERENCES';

interface ISelectionPreferencesState {
    tastes: Array<ITastes> | null,
    brands: Array<IBrands> | null,
    isLoading: boolean | null,
    activeTastesId: Array<number>,
    activeHardnessId: number | null,
    activeBrandsId: Array<number>,
    mixesPreferences: any,
    currentMix: IMix | null
}

interface ISelectionPreferencesAction {
    type: string,
    payload: any
}

const inititalState: ISelectionPreferencesState = {
    tastes: null,
    brands: null,
    isLoading: false,
    activeTastesId: [],
    activeHardnessId: null,
    activeBrandsId: [],
    mixesPreferences: null,
    currentMix: null
};

const addActiveTastesID = (id: number) => {
    return {
        type: ADD_ACTIVE_TASTES_ID,
        payload: id,
    };
};

const removeActiveTastesID = (id: number) => {
    return {
        type: REMOVE_ACTIVE_TASTES_ID,
        payload: id,
    };
};

const setActiveHardnessId = (id: number) => {
    return {
        type: SET_ACTIVE_HARDNESS,
        payload: id,
    };
};

const removeActiveHardnessId = (id: number) => {
    return {
        type: REMOVE_ACTIVE_HARDNESS,
        payload: id,
    };
};

const setActiveBrandsId = (id: number) => {
    return {
        type: ADD_ACTIVE_BRANDS_ID,
        payload: id,
    };
};

const removeActiveBrandsId = (id: number) => {
    return {
        type: REMOVE_ACTIVE_BRANDS_ID,
        payload: id,
    };
};


export const cleanActivePreferences = () => {
    return {
        type: CLEAN_PREFERENCES
    }
};

const setMixesFromServer = (res: Array<IMix>) => async (dispatch: Dispatch) => {
    dispatch(
        {
            type: GET_MIXER_PREF_SUCCESS,
            payload: res
        })
};

const changePreferencesMix = (countLikes: number, isLiked: boolean, indexMix: number) => ({
    type: UPDATE_PREFERENCES_MIX,
    payload: [countLikes, isLiked, indexMix]
});

export const updatePreferencesMix = (id: number, isMixLiked: boolean) => {
    return async (dispatch: Dispatch, getState: () => any) => {
        const mixesPreferences = getState().selectionPreferences.mixesPreferences;
        const mixIndex = mixesPreferences.findIndex((item: any) => item.id === id);
        if (isMixLiked) {
            const res = await MixesAPI.unlikeMix(id);
            dispatch(changePreferencesMix(res.likeCount, false, mixIndex));
        } else {
            const res = await MixesAPI.likeMix(id);
            dispatch(changePreferencesMix(res.likeCount, true, mixIndex));
        }
    }
};

export const setCurrentMix = (id: number) => async (dispatch: Dispatch, getState: () => AppStateType) => {
    const selectionPref = getState().selectionPreferences.mixesPreferences;
    dispatch({
        type: SET_CURRENT_MIX,
        payload: selectionPref[id]
    })
};

export const getUserPreference = () => async (dispatch: Dispatch) => {
    dispatch({type: FETCH_DATA_TOBACCO_START});
    Promise.all([TastesAPI.getListTastes(), BrandsAPI.getBrands()])
        .then(value => {
            dispatch({
                type: GET_TASTES_SUCCESS,
                payload: value[0]
            });
            dispatch({
                type: GET_BRANDS_SUCCESS,
                payload: value[1]
            });
        })
        .catch(e => console.log(e));
};

export const handleTastesId = (id: number) => async (dispatch: Dispatch, getState: () => AppStateType) => {
    const activeTastesId = getState().selectionPreferences.activeTastesId;
    if (activeTastesId.length) {
        activeTastesId.findIndex((item: number) => item === id) === -1
            ? dispatch(addActiveTastesID(id))
            : dispatch(removeActiveTastesID(id));

    } else {
        dispatch(addActiveTastesID(id));
    }
};

export const handleHardnessId = (id: number) => async (dispatch: Dispatch, getState: () => AppStateType) => {
    const activeHardness = getState().selectionPreferences.activeHardnessId;
    activeHardness === null || activeHardness !== id
        ? dispatch(setActiveHardnessId(id))
        : dispatch(removeActiveHardnessId(id));
};

export const handleBrandsId = (id: number) => async (dispatch: Dispatch, getState: () => AppStateType) => {
    const handleBrandsId = getState().selectionPreferences.activeBrandsId;
    if (handleBrandsId.length) {
        handleBrandsId.findIndex((item: number) => item === id) === -1
            ? dispatch(setActiveBrandsId(id))
            : dispatch(removeActiveBrandsId(id));

    } else {
        dispatch(setActiveBrandsId(id));
    }
};

export const sendUserPreferences = () => async (dispatch: Dispatch, getState: () => any) => {
    dispatch({type: GET_MIXER_PREF_START});
    const preferencesState = getState().selectionPreferences;
    MixesAPI.getMixesPreference(
        preferencesState.activeBrandsId,
        preferencesState.activeHardnessId,
        preferencesState.activeTastesId)
        .then(res => dispatch<any>(setMixesFromServer(res)))
        .catch(e => console.log(e));
};

const SelectionPreferencesReducer = (state = inititalState, action: ISelectionPreferencesAction): ISelectionPreferencesState => {
    switch (action.type) {

        case FETCH_DATA_TOBACCO_START: {
            return {
                ...state,
                isLoading: true
            };
        }

        case GET_TASTES_SUCCESS: {
            return {
                ...state,
                tastes: action.payload
            }
        }

        case GET_BRANDS_SUCCESS: {
            return {
                ...state,
                brands: action.payload,
                isLoading: false
            }
        }

        case ADD_ACTIVE_TASTES_ID: {
            return {
                ...state,
                activeTastesId: [...state.activeTastesId, action.payload]
            }
        }

        case REMOVE_ACTIVE_TASTES_ID: {
            return {
                ...state,
                activeTastesId: state.activeTastesId.filter((item: number) => item !== action.payload)
            }
        }

        case SET_ACTIVE_HARDNESS: {
            return {
                ...state,
                activeHardnessId: action.payload
            }
        }

        case REMOVE_ACTIVE_HARDNESS: {
            return {
                ...state,
                activeHardnessId: null,
            }
        }

        case ADD_ACTIVE_BRANDS_ID: {
            return {
                ...state,
                activeBrandsId: [...state.activeBrandsId, action.payload]
            }
        }

        case REMOVE_ACTIVE_BRANDS_ID: {
            return {
                ...state,
                activeBrandsId: state.activeBrandsId.filter((item: number) => item !== action.payload)
            }
        }

        case GET_MIXER_PREF_START: {
            return {
                ...state,
                isLoading: true
            }
        }

        case GET_MIXER_PREF_SUCCESS: {
            return {
                ...state,
                mixesPreferences: action.payload,
                isLoading: false
            }
        }

        case SET_CURRENT_MIX: {
            return {
                ...state,
                currentMix: action.payload
            }
        }

        case UPDATE_PREFERENCES_MIX: {
            const newState: any = [...state.mixesPreferences];
            const [likeCount, isLiked, indexMix] = action.payload;
            newState[indexMix].isLiked = isLiked;
            newState[indexMix].likeCount = likeCount;
            return {
                ...state,
                mixesPreferences: newState
            }
        }

        case CLEAN_PREFERENCES: {
            return {
                ...state,
                activeTastesId: [],
                activeHardnessId: null,
                activeBrandsId: [],
            }
        }

        default:
            return state;
    }
};

export default SelectionPreferencesReducer;
